import type { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { MealStatus } from '../enums/MealStatus'
import type { DeliveryStatus } from '@/features/order/domain/enums/DeliveryStatus'

export class MealEntity {
  id?: string
  company?: {
    id?: number
    name?: string
    location?: LngLatEntity
    logoUrl?: string
  }
  service?: {
    id?: number
    name?: string
  }
  latestDelivery?: {
    createdAt?: string
    updatedAt?: string
    id?: string
    driver?: {
      createdAt?: string
      updatedAt?: string
      id?: number
      workingPhoneNumber?: string | null
      fullName?: string | null
      avatarImagePath?: string | null
    }
    status?: DeliveryStatus
  }
  startAt?: string
  lockAt?: string
  status?: MealStatus
  statusUpdatedAt?: string
  companyPeriodTime?: string
  createdAt?: string
  referenceCode?: string
}
